import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { StyledFormHelperText, StyledErrorIcon, StyledErrorIconPath } from './FormHelperText.styles';

var ErrorIcon = function ErrorIcon() {
  var locale = useLocale();
  return React.createElement(StyledErrorIcon, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, locale.formHelperText.errorIconTitle), React.createElement(StyledErrorIconPath, {
    d: "M21.5,20.5 L1.5,20.5 L11.5,2.5 L21.5,20.5 Z M11.5,16 L11.5,18 M11.5,8 L11.5,14"
  }));
};

export var FormHelperText = React.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'hint' : _ref$variant,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["variant", "disabled", "children"]);

  var showErrorIcon = variant === 'invalid';
  return React.createElement(StyledFormHelperText, _objectSpread({
    variant: variant,
    disabled: disabled,
    ref: ref
  }, pickComponentCommonProps(restProps), {
    outerSpacing: useSpacing(restProps)
  }), showErrorIcon && React.createElement(ErrorIcon, null), children);
});
FormHelperText.displayName = 'FormHelperText';